module.exports = __webpack_public_path__ + "public/img/loading-spin.svg";